import { render, staticRenderFns } from "./CfopRegraDetalhes.vue?vue&type=template&id=5ae7a8c2"
import script from "./CfopRegraDetalhes.vue?vue&type=script&lang=js"
export * from "./CfopRegraDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports